<div *ngIf="control.invalid && (control.dirty || control.touched)" class="validation-container">
  <span class="p-error" *ngIf="control.errors?.required"><i class="pi pi-exclamation-triangle"></i>{{requiredMessage}}</span>
  <ng-content></ng-content>
</div>